<template>
	<div class="row flex-row">
		<div
			v-for="item in items"
			:key="item.ID"
			class="columns column4 filter-item"
			:class="{
				active: filter === item.category || filter === 'showAll',
			}"
		>
			<div class="promotion">
				<nuxt-link class="image" :to="item.filename">
					<picture>
						<source :srcset="item.overviewImageWebp" type="image/webp" />
						<source :srcset="item.overviewImage" />
						<img :src="item.overviewImage" :alt="item.overviewImageAlt" loading="lazy" />
					</picture>
				</nuxt-link>
				<div class="content">
					<h4>
						<nuxt-link :to="item.filename">
							{{ item.header }}
						</nuxt-link>
					</h4>
					<p>{{ item.overviewContent }}</p>
					<nuxt-link :to="item.filename" class="button">
						{{ $t('viewThisPackage') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
}

.promotions .columns {
	display: flex;
}

.promotion {
	background-color: var(--primary-background-color);
	margin: 0 auto 20px;
	box-shadow: 0 0 10px rgb(0 0 0 / 5%);
	position: relative;
	overflow: hidden;

	.content {
		padding-bottom: 90px;

		.button {
			position: absolute;
			bottom: 30px;
			left: 30px;
		}

		h3 a,
		a:not(.button) {
			text-decoration: none;
			color: var(--header-color);
		}
	}

	.image {
		display: block;
		overflow: hidden;

		img {
			transition: all 0.3s ease-in-out;
		}

		&:hover img {
			transform: scale(1.03);
		}
	}
}

@media (max-width: 1080px) {
	.promotions {
		padding: 50px 15px;
	}
}
</style>
